import { LAYOUTS } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goBack, goToLendingPartner, goToPrivacy, goToProductDetail, goToTerms } from "./actions";
export const template = (height) => {
    return {
        layout: {
            id: ROUTE.ABOUTUS,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'aboutUsScreen', type: WIDGET.ABOUT_US_SCREEN_DC,
                },
            ],
        },
        datastore: {
            aboutUsScreen: {
                height,
                backAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.ABOUTUS,
                },
                termsAction: {
                    payload: {},
                    type: ACTION.GO_TO_TERMS,
                    routeId: ROUTE.ABOUTUS,
                },
                privacyAction: {
                    payload: {},
                    type: ACTION.GO_TO_PRIVACY,
                    routeId: ROUTE.ABOUTUS,
                },
                lendingPartnerAction: {
                    payload: {},
                    type: ACTION.LENDING_PARTNER,
                    routeId: ROUTE.ABOUTUS,
                },
                productDetailAction: {
                    payload: {},
                    type: ACTION.PRODUCT_DETAILS,
                    routeId: ROUTE.ABOUTUS,
                },
            }
        },
    };
};
export const aboutUsMF = {
    onLoad: async ({ getHeight }) => {
        return Promise.resolve(template(getHeight()));
    },
    actions: {
        // [ACTION.ACCOUNT_DETAILS]: accountDetails,
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.GO_TO_PRIVACY]: goToPrivacy,
        [ACTION.GO_TO_TERMS]: goToTerms,
        [ACTION.LENDING_PARTNER]: goToLendingPartner,
        [ACTION.PRODUCT_DETAILS]: goToProductDetail,
    },
    bgColor: "#FFFFFF",
};
